$(document).ready(function() {
    $(".grid__item .product-bottom-text .product-price").matchHeight({
        byRow: !0
    }), $("button.sort").on("click", function() {
        $("body").addClass("sort-open")
    }), $(document).on("click", ".js-clear-filter", function() {
        $(".boost-pfs-filter-clear-all").trigger("click")
    }), $("button.value-picker__close").on("click", function() {
        $("body").removeClass("sort-open")
    }), $(".brand-section-column .brand-section-text").matchHeight({
        byRow: !0
    }), $(".tabs a").mouseover(function() {
        $(".panel").hide(),
        $(".tabs a.active").removeClass("active"),
        $(this).addClass("active");
        var t = $(this).attr("data-href");
        return $(t).fadeIn(500), !1
    }), $(".tabs li:first a").mouseover(),
    $(".slider-for").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: !0,
        arrows: !0,
        infinite: !1,
        focusOnSelect: !0,
        asNavFor: ".slider-nav",
        prevArrow: '<button type="button" class="prev-arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.30409 0.330173C8.5155 0.541647 8.63426 0.828428 8.63426 1.12745C8.63426 1.42648 8.5155 1.71326 8.30409 1.92473L2.72201 7.50681L8.30409 13.0889C8.50951 13.3016 8.62317 13.5864 8.6206 13.8821C8.61803 14.1778 8.49943 14.4606 8.29035 14.6697C8.08127 14.8788 7.79843 14.9974 7.50275 15C7.20707 15.0025 6.92222 14.8889 6.70953 14.6834L0.330173 8.30409C0.118763 8.09261 0 7.80583 0 7.50681C0 7.20778 0.118763 6.921 0.330173 6.70953L6.70953 0.330173C6.921 0.118763 7.20779 0 7.50681 0C7.80583 0 8.09261 0.118763 8.30409 0.330173Z" fill="#949494"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.695913 14.6698C0.484503 14.4584 0.36574 14.1716 0.36574 13.8725C0.36574 13.5735 0.484503 13.2867 0.695913 13.0753L6.27799 7.49319L0.695914 1.91111C0.490496 1.69843 0.37683 1.41357 0.379401 1.11789C0.38197 0.822215 0.500568 0.539376 0.709651 0.330292C0.918734 0.121209 1.20157 0.00261239 1.49725 4.32131e-05C1.79293 -0.00252691 2.07779 0.111139 2.29047 0.316557L8.66983 6.69591C8.88124 6.90739 9 7.19417 9 7.49319C9 7.79222 8.88124 8.079 8.66983 8.29047L2.29047 14.6698C2.079 14.8812 1.79221 15 1.49319 15C1.19417 15 0.907387 14.8812 0.695913 14.6698Z" fill="#949494"/></svg></button>'
    }), $(".slider-nav").slick({
        slidesToShow: 1,
        infinite: !1,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        fade: !0,
        dots: !1,
        arrows: !1,
        prevArrow: '<button class="slick-prev slick-arrow"><i class="demo-icon icon-left-open-big"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow"><i class="demo-icon icon-right-open-big"></i></button>'
    }), $(".product-type-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: !1,
        arrows: !1,
        rows: 0,
        prevArrow: "<button type='button' class='slick-prev icon-angle-left'><i class='demo-icon icon-left-open-big'></i></button>",
        nextArrow: "<button type='button' class='slick-next icon-angle-right'><i class='demo-icon icon-right-open-big'></i></button>",
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1,
                dots: !1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.3,
                dots: !1
            }
        }]
    }), $(".filter li").on("click", function() {
        var t = $(this).data("filter");
        $(".product-type-slider").slick("slickUnfilter"), "timoteo" == t ? $(".product-type-slider").slick("slickFilter", ".timoteo") : "cellblock" == t ? $(".product-type-slider").slick("slickFilter", ".cellblock") : "vaux" == t && $(".product-type-slider").slick("slickFilter", ".vaux")
    }), $(".product-tab-wrapper").on("click", function() {
        $(this).addClass("active"), $(this).parent().siblings().find(".product-tab-wrapper").removeClass("active")
    });
    var t = $(".filter li").first().attr("data-filter");
    $(".product-type-slider").slick("slickUnfilter"), $(".product-type-slider").slick("slickFilter", "." + t), $(".shop_by_category a.nav-item.nav-link").on("mouseover", function(t) {
        var e = $(this).attr("data-id");
        $(".shop_by_brand_menu_system .product-tab .tab-pane.active.show").removeClass("active").removeClass("show"), $("#" + e).addClass("active"), $("#" + e).addClass("show"), $(".shop_by_category a.nav-item.nav-link").removeClass("active"), $(this).addClass("active")
    }), $(".shop_by_brand a.nav-item.nav-link").on("mouseover", function(t) {
        var e = $(this).attr("data-id");
        $(".product-tab .tab-panes.active.show").removeClass("active").removeClass("show"), $("#" + e).addClass("active"), $("#" + e).addClass("show"), $(".shop_by_brand a.nav-item.nav-link").removeClass("active"), $(this).addClass("active")
    }), $(".new-header-toggle .js-drawer-open-nav").on("click", function() {
        $(".drawer.drawer--right").addClass("menu-open"), $("body").addClass("menu-open"), $("html").addClass("menu-open")
    }), $(".close_btn").on("click", function() {
        $(".drawer.drawer--right").removeClass("menu-open"), $("body").removeClass("menu-open"), $("html").removeClass("menu-open")
    }), $(".submenu_list > a").click(function(t) {
        t.preventDefault(), $(this).parents(".submenu_list").addClass("open-sub-menu")
    }), $(".submenu_list > .icon-arrow").click(function(t) {
        t.preventDefault(), $(this).parents(".submenu_list").addClass("open-sub-menu")
    }), $(".brand-logo-wrapper").click(function(t) {
        t.preventDefault(), $(this).parent().addClass("open-sub-menus")
    }), $(".brand-logo-submenu .back-menu").click(function(t) {
        t.preventDefault(), $(this).parents().removeClass("open-sub-menus")
    }), $(".submenu_list > .submenu_drawer > .back-menu > .back_drawer").click(function(t) {
        t.preventDefault(), $(this).parents(".submenu_list").removeClass("open-sub-menu")
    }), $(".new-banner-slider-wrapper").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: !1,
        arrows: !1,
        dots: !1,
        prevArrow: "<button type='button' class='slick-prev icon-angle-left'><i class='demo-icon icon-left-open-big'></i></button>",
        nextArrow: "<button type='button' class='slick-next icon-angle-right'><i class='demo-icon icon-right-open-big'></i></button>",
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                dots: !1
            }
        }]
    });

  // ME Comment
    // $(".site-nav-cart").on("click", function() {
    //     $(".drawer.drawer--right").removeClass("menu-open"), $("body").removeClass("menu-open"), $("html").removeClass("menu-open"),
    //     $(".drawer--rights").addClass("sidebar-open"), $("body").addClass("sidebar-open")
    // }), $(document).on("click", ".drawer__close button", function() {
    //     $(".drawer--rights").removeClass("sidebar-open"), $("body").removeClass("sidebar-open")
    // }), $(document).mouseup(function(t) {
    //     $(".drawer--rights").is(t.target) || 0 !== $(".drawer--rights").has(t.target).length || ($(".drawer--rights").removeClass("sidebar-open"), $("body").removeClass("sidebar-open"))
    // }), $(".qty-input button").on("click", function() {
    //     val = parseInt($(this).parent().find("input").val()), $(this).hasClass("less") ? val -= 1 : $(this).hasClass("more") && (val += 1), val < 1 && (val = 1), $(this).parent().find("input").val(val)
    // }), $(document).on("change", ".product-wrapper form select.product-single__variants", t => {
    //     console.log(120);
    //     /*
    //     let e = $(t.target).parents(".product-wrapper").eq(0),
    //         s = $(t.target).find("option:selected").attr("data-imageurl"),
    //         o = $(t.target).find("option:selected").attr("data-price"),
    //         i = $(t.target).find("option:selected").attr("data-compareat-price"),
    //         a = $(t.target).find("option:selected").attr("data-discount"),
    //         n = $(t.target).find("option:selected").attr("data-available");
    //     console.log(i), "false" == n && void 0 !== n ? ($(e).find(".product-cart-btn").html('<button type="submit" style="pointer-events:none;" name="add" class="add-to-cart-text  add-to-cart" <span> sold out </span></button>'), $(e).find(".product-cart-btn button").css("background", "#949494"), $(e).find(".product-label .sold-out").show()) : ($(e).find(".product-cart-btn").html('<button type="submit" name="add" class="add-to-cart-text  add-to-cart"><img src="https://cdn.shopify.com/s/files/1/1782/0407/files/icon-bag.svg?v=1670497154"> <span> order </span></button>'), $(e).find(".product-label .sold-out").hide()), $(e).find(".product-top-img-wrapper figure img").attr("src", s), null == i || void 0 === i || "" == i ? $(e).find(".product-price ").html(`<h5>${o}</h5>`) : $(e).find(".product-price ").html(`<h5 class='sale-price'><span>${o}<del>${i}</del></span><label>${a}% Off</label></h5>`)
    //     */
    //     let e = $(t.target).closest(".product-wrapper"),
    //     selectedOption = $(t.target).find("option:selected"),
    //     s = selectedOption.data("imageurl"),
    //     o = selectedOption.data("price"),
    //     i = selectedOption.data("compareat-price"),
    //     a = selectedOption.data("discount"),
    //     n = selectedOption.data("available");
        
    //     let compare_at_price_float = parseFloat(i.toString().replace("$",""));

    //     // Update button and sold-out label based on availability
    //     if (n === "false") {
    //         e.find(".product-cart-btn").html(`
    //             <button type="submit" style="pointer-events:none;" name="add" class="add-to-cart-text add-to-cart">
    //                 <span> sold out </span>
    //             </button>
    //         `).find("button").css("background", "#949494");
    //         e.find(".product-label .sold-out").show();
    //     } else {
    //         e.find(".product-cart-btn").html(`
    //             <button type="submit" name="add" class="add-to-cart-text add-to-cart">
    //                 <img src="https://cdn.shopify.com/s/files/1/1782/0407/files/icon-bag.svg?v=1670497154">
    //                 <span> order </span>
    //             </button>
    //         `);
    //         e.find(".product-label .sold-out").hide();
    //     }

    //     // Update product image
    //     e.find(".product-top-img-wrapper figure img").attr("src", s);

    //     // Update product price
    //     if (!i || compare_at_price_float == 0) {
    //         e.find(".product-price").html(`<h5>${o}</h5>`);
    //     } else {
    //         e.find(".product-price").html(`
    //             <h5 class='sale-price'>
    //                 <span>${o}<del>${i}</del></span>
    //                 <label>${a}% Off</label>
    //             </h5>
    //         `);
    //     }
    // });
  
});

$(document).ready(function() {
    $(".size-guide-poup").on("click", function() {
        $("body").addClass('show-sizeguide');
    });
    $(".close-sizeguide").on("click", function() {
        $("body").removeClass('show-sizeguide');
    });

    $(document).on('click','.pdp-accordian .item .accordian-title', function(e){
      e.preventDefault();
      let $this = $(this);
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.item .accordian-details').removeClass('show');
          $this.parent().parent().find('.item .accordian-details').slideUp(350);
          $this.next().toggleClass('show');
          $this.next().slideToggle(350);
      }
    });

    $(document).on('click','.pdp-accordian .item .accordian-title', function(){
       $(this).parent().siblings().removeClass('active');
       $(this).parent().toggleClass('active');
    });
  
  
    if ($('.customers-view-product-slider').length > 0) {
        $('.customers-view-product-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="24" height="39" viewBox="0 0 24 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.5364 0.719681C24.2435 1.56824 24.1288 2.82936 23.2803 3.53649L4.12402 19.5L23.2803 35.4636C24.1288 36.1707 24.2435 37.4319 23.5364 38.2804C22.8292 39.129 21.5681 39.2436 20.7196 38.5365L1.56329 22.5729C-0.35573 20.9738 -0.355732 18.0263 1.56329 16.4272L20.7196 0.463608C21.5681 -0.243521 22.8292 -0.128873 23.5364 0.719681Z" fill="#949494"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="24" height="39" viewBox="0 0 24 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.463634 0.719681C-0.243494 1.56824 -0.128847 2.82936 0.719707 3.53649L19.876 19.5L0.719707 35.4636C-0.128847 36.1707 -0.243494 37.4319 0.463634 38.2804C1.17076 39.129 2.43189 39.2436 3.28045 38.5365L22.4367 22.5729C24.3557 20.9738 24.3557 18.0263 22.4367 16.4272L3.28045 0.463608C2.43189 -0.243521 1.17076 -0.128873 0.463634 0.719681Z" fill="#949494"/></svg></button>',
            responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });
    }
    if ($('#accordionQuestion').length > 0) {
        $(".faq-item > .faq-question").on("click", function() {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".faq-answer").slideUp();
            } else {
                $(".faq-item > .faq-question").removeClass("active");
                $(this).addClass("active");
                $(".faq-answer").slideUp();
                $(this).siblings(".faq-answer").slideDown();
            }
        });
    }
    if ($('.customer-viewed-sliders').length > 0) {
        $('.customer-viewed-sliders').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.1138 0.933719C20.7031 1.64085 20.6075 2.69179 19.9004 3.28106L3.93685 16.584L19.9004 29.887C20.6075 30.4763 20.7031 31.5272 20.1138 32.2343C19.5245 32.9415 18.4736 33.037 17.7665 32.4477L1.8029 19.1448C0.203721 17.8121 0.203719 15.3559 1.8029 14.0233L17.7665 0.720324C18.4736 0.131051 19.5245 0.226591 20.1138 0.933719Z" fill="#323232"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.886198 32.0663C0.296925 31.3592 0.392464 30.3082 1.09959 29.7189L17.0632 16.416L1.0996 3.11301C0.392466 2.52373 0.296927 1.47279 0.886201 0.765664C1.47547 0.0585365 2.52641 -0.0370057 3.23354 0.55227L19.1971 13.8552C20.7963 15.1879 20.7963 17.6441 19.1971 18.9767L3.23354 32.2797C2.52641 32.8689 1.47547 32.7734 0.886198 32.0663Z" fill="#323232"/></svg></button>',
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.3,
                        arrows: false,
                    }
                }
            ]
        });
    }
});


function mobileOnlySlider() {
    if ($('.you-may-also-like').length > 0) {
        $('.you-may-also-like .product-list').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="24" height="39" viewBox="0 0 24 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.5364 0.719681C24.2435 1.56824 24.1288 2.82936 23.2803 3.53649L4.12402 19.5L23.2803 35.4636C24.1288 36.1707 24.2435 37.4319 23.5364 38.2804C22.8292 39.129 21.5681 39.2436 20.7196 38.5365L1.56329 22.5729C-0.35573 20.9738 -0.355732 18.0263 1.56329 16.4272L20.7196 0.463608C21.5681 -0.243521 22.8292 -0.128873 23.5364 0.719681Z" fill="#949494"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="24" height="39" viewBox="0 0 24 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.463634 0.719681C-0.243494 1.56824 -0.128847 2.82936 0.719707 3.53649L19.876 19.5L0.719707 35.4636C-0.128847 36.1707 -0.243494 37.4319 0.463634 38.2804C1.17076 39.129 2.43189 39.2436 3.28045 38.5365L22.4367 22.5729C24.3557 20.9738 24.3557 18.0263 22.4367 16.4272L3.28045 0.463608C2.43189 -0.243521 1.17076 -0.128873 0.463634 0.719681Z" fill="#949494"/></svg></button>',
            responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });
    }
}
if (window.innerWidth < 768) {
    mobileOnlySlider();
}

$(window).on("load resize scroll", function(e) {

    if (window.innerWidth < 768) {
        if (!$('.you-may-also-like .product-list').hasClass('slick-initialized')) {
            setTimeout(() => {
                mobileOnlySlider();
            }, 100);
        }
    } else {
        if ($('.you-may-also-like .product-list').hasClass('slick-initialized')) {
            $('.you-may-also-like .product-list').slick('unslick');
        }
    }

});

    $('.pdp-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="prev-arrow"><svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.1138 0.933719C20.7031 1.64085 20.6075 2.69179 19.9004 3.28106L3.93685 16.584L19.9004 29.887C20.6075 30.4763 20.7031 31.5272 20.1138 32.2343C19.5245 32.9415 18.4736 33.037 17.7665 32.4477L1.8029 19.1448C0.203721 17.8121 0.203719 15.3559 1.8029 14.0233L17.7665 0.720324C18.4736 0.131051 19.5245 0.226591 20.1138 0.933719Z" fill="#323232"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow"><svg width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.886198 32.0663C0.296925 31.3592 0.392464 30.3082 1.09959 29.7189L17.0632 16.416L1.0996 3.11301C0.392466 2.52373 0.296927 1.47279 0.886201 0.765664C1.47547 0.0585365 2.52641 -0.0370057 3.23354 0.55227L19.1971 13.8552C20.7963 15.1879 20.7963 17.6441 19.1971 18.9767L3.23354 32.2797C2.52641 32.8689 1.47547 32.7734 0.886198 32.0663Z" fill="#323232"/></svg></button>',
        asNavFor: '.pdp-slider-nav',
        responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    });
    $('.pdp-slider-nav').slick({
        slidesToShow: 6.3,
        slidesToScroll: 1,
        asNavFor: '.pdp-slider-for',
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="prev-arrow"><svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.7803 23.5373C37.9318 24.2445 36.6706 24.1298 35.9635 23.2813L20 4.125L4.03639 23.2813C3.32926 24.1298 2.06813 24.2445 1.21958 23.5373C0.371028 22.8302 0.256377 21.5691 0.963508 20.7205L16.9271 1.56426C18.5262 -0.354754 21.4737 -0.354756 23.0728 1.56426L39.0364 20.7205C39.7435 21.5691 39.6289 22.8302 38.7803 23.5373Z" fill="#949494"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow"><svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.21968 0.462658C2.06824 -0.244471 3.32936 -0.129824 4.03649 0.718731L20 19.875L35.9636 0.718731C36.6707 -0.129823 37.9319 -0.24447 38.7804 0.462658C39.629 1.16979 39.7436 2.43091 39.0365 3.27947L23.0729 22.4357C21.4738 24.3548 18.5263 24.3548 16.9272 22.4357L0.963608 3.27947C0.25648 2.43091 0.371128 1.16978 1.21968 0.462658Z" fill="#949494"/></svg></button>',
        focusOnSelect: true
    });
$('.accordian .toggle').click(function(e) {
            e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass('open-faq')) {
              $this.next().removeClass('open-faq');
              $this.next().slideUp(350);
          } else {
              $this.parent().parent().find('li .inner').removeClass('open-faq');
              $this.parent().parent().find('li .inner').slideUp(350);
              $this.next().toggleClass('open-faq');
              $this.next().slideToggle(350);
          }
        });
        $('.accordian li a').on('click', function(){
            $(this).parent().siblings().removeClass('open-faq');
            $(this).parent().toggleClass('open-faq');
        });

$(document).ready(function() {
    $('.article-content-section-left ul li a').bind('click', function(e) {
            e.preventDefault();
            var target = $(this).attr("href");
            $('html, body').stop().animate({
                    scrollTop: $(target).offset().top
            }, 600, function() {
                    location.hash = target;
            });
            return false;
    });

    // $('.faq-accordion .faq-ans').hide();
    // $('.faq-accordion .faq-accordion-items').removeClass('open');

    $('.faq-accordion .faq-que').click(function() {
        if ($(this).parents('.faq-accordion-items').hasClass("open")) {
            $(this).parents('.faq-accordion-items').removeClass("open").find(".faq-ans").slideUp();
        } else {
            $(".faq-accordion > .faq-accordion-items.open .faq-ans").slideUp();
            $(".faq-accordion > .faq-accordion-items.open").removeClass("open");
            $(this).parents('.faq-accordion-items').addClass("open").find(".faq-ans").slideDown();
        }
        return false;
    });

    $(".new-blog-post .new-blog-post-wrap .box-wrap .box .blog-desc .match-height").matchHeight({
        byRow: true,
    });

    // copy content to clipboard
    function copyToClipboard(text) {
        var input = document.createElement('input');
        input.style.position = 'fixed';
        input.style.opacity = 0;
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
    }

    // copy coupon code to clipboard
    $(".js-coupon-btn").on("click", function() {
        var couponCode = $(this).data('coupon');
        copyToClipboard(couponCode);
        $(".js-coupon-card").fadeIn("slow");
        setTimeout(function() {
            $(".js-coupon-card").fadeOut("slow");
        }, 2000);
    });


    // Header 3.0 Changes Start Here
    $(".js-hemburge-menu").click(function(){
        let getHeaderHeight = $('.header-3').outerHeight();
        $('.header-3__nav').css("height", "calc(100vh - " + getHeaderHeight + "px)");
        $('.header-3__nav').css("top", getHeaderHeight + "px");
        $(this).toggleClass("is-active");
        $('body').toggleClass('open-menu');
    });

    $(document).on('click','body.open-menu .nav-items--has-megamenu .js-mb-nav-btn', function(){

        if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next().slideUp();
		} else{
			$('.header-3__megamenu').slideUp();
			$('.js-mb-nav-btn').removeClass('active');
			$(this).addClass('active');
            $(this).next().slideDown();
		}
    });

    $(document).on("click", function(event){
        var $trigger = $(".header-3__hemburger-menu, .header-3__nav");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $(".js-hemburge-menu").removeClass('is-active');
            $('.js-mb-nav-btn').removeClass('active');
            $('.header-3__megamenu').slideUp();
            $("body.open-menu").removeClass("open-menu");
        }
    });

    // Header 3.0 Changes Over Here
});
$(window).scroll(function() {
		var scrollDistance = $(window).scrollTop();
		$('.article-content-column').each(function(i) {
				if ($(this).position().top <= scrollDistance) {
						$('.article-content-section-left ul li.active').removeClass('active');
						$('.article-content-section-left ul li').eq(i).addClass('active');
				}
		});
}).scroll();

// =============Custom=================

$(document).ready(function(){
   $('input[type="hidden"][name="id"].product-variant-id').removeAttr("disabled");
  
    $(document).on("change", ".product-single__form-atc .product-variant input[type='radio']", function(e) {
    e.preventDefault();

    const $this = $(this);
    const $wrapper = $this.closest('.product-wrapper');
  
    const selected_variant_ID = $this.attr('curr_var_id');
    const selected_variant_PRICE = $this.attr('curr_var_price');
    const selected_variant_COMPARE_PRICE = $this.attr('curr_var_compare_price');
    const selected_variant_DISCOUNT = $this.attr('curr_var_discount');
    const selected_variant_AVAILABLE = $this.attr('curr_var_available') === 'true';
    const selected_variant_IMAGE = $this.attr('curr_var_img');
      
    $wrapper.find('.product-variant-id').val(selected_variant_ID);
    $wrapper.find('.product-variant-id').removeAttr("disabled");   
      
    if (selected_variant_IMAGE) {
      $wrapper.find('.product-top-img-wrapper img').attr('src', selected_variant_IMAGE);
    }
  
    if (selected_variant_COMPARE_PRICE > selected_variant_PRICE) {
      $wrapper.find('.product-price .sale-price span.block_product_price').text(selected_variant_PRICE);
      $wrapper.find('.product-price .sale-price del').text(selected_variant_COMPARE_PRICE);
      $wrapper.find('.product-price .sale-price .discount-percentage .discount-amount').text(selected_variant_DISCOUNT);
    } else {
      $wrapper.find('.product-price .sale-price').text(selected_variant_PRICE);
    }
  
    if (selected_variant_AVAILABLE) {
       console.log('selected_variant_AVAILABLE tt',selected_variant_AVAILABLE);
      $wrapper.find('.quick-atc-btn .quick-add__submit span').text('Order');
      $wrapper.find('.quick-atc-btn .quick-add__submit').prop('disabled',false);
    } else {
       console.log('selected_variant_AVAILABLE ff',selected_variant_AVAILABLE);
      $wrapper.find('.quick-atc-btn .quick-add__submit span').text('Sold Out');
      $wrapper.find('.quick-atc-btn .quick-add__submit').prop('disabled',true);
      
    }
  });


     $(document).on("change", ".js-main-select select", function(t) {
        t.preventDefault();
        let parent = $(t.target).parents(`.add_items_block`);
          var didFind = false;
          var isUnavailableMatch = false;
          var optionsArray = [];
          
          parent.find($(".js-main-select select")).each(function () { 
            var currentSelectElement = $(this);
            var selectedValue = currentSelectElement.find("option:selected").val();
            optionsArray.push($(this).val()); 
          });
          
          var variantsOption = optionsArray.join(" / ");
          $(this).prop("selected", false);
          
          parent.find("#js-product-dropdown option").each(function () {
            var currentOption = $(this);
            if (variantsOption == currentOption.text()) {
              $(this).prop("selected", true);
              
              if (currentOption.attr('data-available') == "true") {
                didFind = true;
          
                var test1 = parent.find("#js-product-dropdown option:selected").attr("data-price");
                parent.find('.js_rec_price').html(test1);
          
              } else {
                isUnavailableMatch = true;
                return false; 
              }
            }
          });

         if (didFind == false) {
            parent.find(".quick-add__submit").html("<span>Sold Out</span>");
            parent.find(".quick-add__submit").prop("disabled", true);
        } else {
            parent.find(".quick-add__submit").html('<span>Add <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.70988 1.00977V13.7498" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round"></path><path d="M1.33984 7.37883H14.0798" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round"></path></svg></span><div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>');
            parent.find(".quick-add__submit").prop("disabled", false);
        }
        if (!didFind && !isUnavailableMatch) {
            parent.find(".quick-add__submit").html("<span>Not Available</span>");
            parent.find(".quick-add__submit").prop("disabled", true);
        }
   
         var rec_selected_var_id =  $(this).parents('.add_items_block').find('select.actual-variants option:selected').val();
         var rec_selected_var_img = $(this).parents('.add_items_block').find('select.actual-variants option:selected').attr('data-image');
         var rec_selected_var_price = $(this).parents('.add_items_block').find('select.actual-variants option:selected').attr('data-price');
         var rec_selected_var_compare_price = $(this).parents('.add_items_block').find('select.actual-variants option:selected').attr('data-compareat-price');
         var rec_selected_var_discount_save = $(this).parents('.add_items_block').find('select.actual-variants option:selected').attr('data-discount');
         $(this).parents('.add_items_block').find('.product-variant-id').val(rec_selected_var_id);
         $(this).parents('.add_items_block').find('.items_img img').attr('src',rec_selected_var_img);
         
         if(rec_selected_var_compare_price){
           $(this).parents('.add_items_block').find('.price').addClass('on-sale');
           $(this).parents('.add_items_block').find('.price .js_rec_price').text(rec_selected_var_price);
           $(this).parents('.add_items_block').find('.price .js_compare_price').text(rec_selected_var_compare_price);
           $(this).parents('.add_items_block').find('.price .discount-amount').text(rec_selected_var_discount_save);
         }else{
           $(this).parents('.add_items_block').find('.price').removeClass('on-sale');
           $(this).parents('.add_items_block').find('.price .js_rec_price').text(rec_selected_var_price);
         }
      });
  
})

